import { register } from "async-ops";
import { callMvcApi  } from "../../../../../call-web-api";
export const GET_SELECTED_CASE_PAY_LINES = 'GET_SELECTED_CASE_PAY_LINES';

export const service = async (data) => {
    const options: object = {
      url: `/api/ExternalAudit/GetSelectedCasePayLines/${data.eaCaseId}/${data.caseDetailId}/${data.varToUpdate}`,
      method: "GET",
    };
    const response = callMvcApi(options);
    return response;
  };

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_SELECTED_CASE_PAY_LINES, service, mock);
